import React from 'react';
import { Box, Typography, Container, Divider, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import '../assets/fonts/fonts.css';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

const Vehicle = () => {

  return (
    <Box 
      sx={{ 
        py: 6, 
        bgcolor: '#f5f0e5' // Couleur beige élégante
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}
        >
          <Box 
            sx={{ 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              mb: 2
            }}
          >
            <DirectionsCarIcon 
              sx={{ 
                fontSize: 40, 
                color: 'primary.main',
                mb: 2,
                opacity: 0.9
              }} 
            />
            <Typography 
              variant="h4" 
              component="h2" 
              gutterBottom
              sx={{
                fontWeight: 500,
                color: 'text.primary',
                letterSpacing: '0.5px',
                fontFamily: '"Satisfy", cursive'
              }}
            >
              Notre véhicule
            </Typography>
            <Divider 
              sx={{ 
                width: '60px', 
                borderColor: 'primary.main', 
                borderWidth: 2,
                my: 2
              }} 
            />
            <Typography 
              variant="body1" 
              sx={{ 
                color: 'text.secondary',
                maxWidth: '600px',
                mx: 'auto',
                mb: 2
              }}
            >
              Berline confortable avec intérieur soigné et équipements de qualité pour vos déplacements en toute tranquillité
            </Typography>
            
            <Typography 
              variant="body1" 
              sx={{ 
                color: 'text.secondary',
                maxWidth: '600px',
                mx: 'auto',
                mb: 3,
                fontWeight: 500
              }}
            >
              Sièges massants et ventilés pour un confort optimal durant votre trajet
            </Typography>
            
            {/* Espace pour les photos du véhicule */}
            <Box sx={{ width: '100%', mt: 4 }}>
              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} sm={6}>
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true }}
                  >
                    <Paper
                      elevation={3}
                      sx={{
                        height: 250,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f0e8d9',
                        borderRadius: 2,
                        overflow: 'hidden',
                        position: 'relative'
                      }}
                    >
                      <img
                        src={require('../assets/images/banner.jpg')}
                        alt="Extérieur du véhicule"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </Paper>
                  </motion.div>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    viewport={{ once: true }}
                  >
                    <Paper
                      elevation={3}
                      sx={{
                        height: 250,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f0e8d9',
                        borderRadius: 2,
                        overflow: 'hidden',
                        position: 'relative'
                      }}
                    >
                      <img
                        src={require('../assets/images/interieur.png')}
                        alt="Intérieur du véhicule avec sièges massants et ventilés"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </Paper>
                  </motion.div>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Vehicle;
